import React, { useEffect, useState } from 'react';
import { ISlidersProps } from './Tabs.types';

//import { CustomScroll } from 'react-custom-scroll';

// STYLES
import styles from '../../UILayer.scss';

export const Sliders: React.FC<ISlidersProps> = ({ focusedIdx, slides, theme }) => {
    const translateXValue: number = -focusedIdx * 100;

    const [page, setPage] = useState<number>(0);

    const sliderStyles: React.CSSProperties = {
        transform: `translateX(${translateXValue}%)`,
        transitionDuration: '300ms'
    };

    useEffect(() => {}, [focusedIdx, slides]);

    return (
        <div className={`${styles['outer-sliders']} ${theme}`} style={{ flex: 1, minHeight: 0, minWidth: 0 }}>
            <div className={styles.sliders}>{slides[focusedIdx].content}</div>
        </div>
    );
};

//  <Container>{slide.content}</Container>

/*
            <CustomScroll className={styles.customScroll} heightRelativeToParent="100%">
                <div className={styles.sliders}>{slides[focusedIdx].content}</div>
            </CustomScroll>


export const Sliders: React.FC<ISlidersProps> = ({ focusedIdx, slides, theme }) => {
    const translateXValue: number = -focusedIdx * 100;

    const [contentHeight, setPage] = useState<number>(0);

    const sliderStyles: React.CSSProperties = {
        transform: `translateX(${translateXValue}%)`,
        transitionDuration: '300ms'
    };

    useEffect(() => {



        console.log('slides', slides, focusedIdx);
    }, [focusedIdx, slides]);

    return (
        <div className={`${styles['outer-sliders']} ${theme}`}>
            <div className={styles.sliders} style={sliderStyles}>
                {slides.map((slide, index) => (
                    <div key={`slide_${slide.id}`} className={styles.slide} data-slide={index}>
                        {slide.content}
                    </div>
                ))}
            </div>
        </div>
    );
};
*/
